/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_Connection_TabInputs */



/**
* | output |
* | --- |
* | "Connection" |
*
* @param {Live_Caption_Connection_TabInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_connection_tab = /** @type {((inputs?: Live_Caption_Connection_TabInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_Connection_TabInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Connexion")
	if (locale === "de") return /** @type {LocalizedString} */ ("Verbindung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Connessione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Связь")
	if (locale === "es") return /** @type {LocalizedString} */ ("Conexión")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("联系")
	if (locale === "ja") return /** @type {LocalizedString} */ ("繋がり")
	if (locale === "hi") return /** @type {LocalizedString} */ ("संबंध")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Conexão")
	return /** @type {LocalizedString} */ ("Connection")
});